export const init = (licenseKey, applicationId) => {
  if (window.NREUM && licenseKey && applicationId) {
    window.NREUM.info = {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: licenseKey,
      applicationID: applicationId,
      sa: 1
    }
  }
}



// WEBPACK FOOTER //
// ./app/newrelic/index.js